import { Box, Image } from '@chakra-ui/react';

import { TextMedium, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const PurchaseProductCard = ({ item, isLast }) => {
  return (
    <Box className={`${styles['purchase-product-card__container']} ${!isLast ? styles['purchase-product-card__container--bordered'] : ''}`}>
      <Image src={item?.imagePath} boxSize="45px" borderRadius="4px" objectFit="cover" />
      <Box>
        <TextMedium className={styles['purchase-product-card__text--product-name']}>{item?.productName}</TextMedium>
        <TextRegular className={styles['purchase-product-card__text--sku']}>{item?.sku || '-'}</TextRegular>
      </Box>
    </Box>
  );
};

export default PurchaseProductCard;
